"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/22e5c256-8e12-4e8f-a658-7d339c9e9ebc
 * name: IcNaviBack
 */
function IcNaviBack() {
    return null;
}
exports.default = IcNaviBack;
;
